export default __webpack_public_path__ + "static/media/burnbutton.2191968d.png";